import { InfoCircleOutlined } from "@ant-design/icons";
import { Card, Spin, Tooltip } from "antd";
import useCollectionsZonesRevenue from "../../hooks/useCollectionsZonesRevenue";
import CollectionZoneTimeline from "./CollectionZoneTimeline";

export default function CollectionsTimeLineWrapper({
  selectedZones,
  selectedDate,
  selectedPeriod,
}) {
  const {
    data: collectionsZonesRevenue,
    isLoading: isCollectionsZonesRevenueLoading,
    error: collectionsZonesRevenueError,
  } = useCollectionsZonesRevenue({
    date: selectedDate,
    period: selectedPeriod,
    enabled: !!selectedDate,
  });

  return (
    <Card
      title={
        <>
          {"Timeline de Coleções por Zona"}
          <Tooltip
            title={
              "A intensidade da cor representa o faturamento: quanto mais escura, maior o faturamento médio diário."
            }>
            <InfoCircleOutlined style={{ marginLeft: 10 }} />
          </Tooltip>
        </>
      }
      align="center"
      style={{
        width: "85%",
        height: "450px",
      }}
      bodyStyle={{
        height: "calc(100% - 58px)",
        overflow: "auto",
        padding: "24px",
        margin: 0,
      }}
      styles={{
        header: { backgroundColor: "#d0d6e2" },
        body: {
          display: "flex",
          flexDirection: "column",
        },
      }}>
      <div
        style={{
          flex: 1,
          width: "100%",
          minWidth: "500px",
          maxHeight: "350px",
        }}>
        {isCollectionsZonesRevenueLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "50px",
            }}>
            <Spin size="large" />
          </div>
        )}
        {collectionsZonesRevenue && (
          <CollectionZoneTimeline
            collectionsData={collectionsZonesRevenue}
            error={collectionsZonesRevenueError}
            appliedZones={selectedZones}
            selectedDate={selectedDate}
          />
        )}
      </div>
    </Card>
  );
}
